import detectEthereumProvider from "@metamask/detect-provider";
import MetaMaskOnboarding from "@metamask/onboarding";
import hash from "keccak256";
import { MerkleTree } from "merkletreejs";
import Web3 from "web3";
import { toChecksumAddress } from "web3-utils";
import { requiredChainId, requiredChainIdName } from "../libs/smart-contract";

const msg_mobile = "Please use MetaMask!";
const msg_desk = "Please intall MetaMask Wallet extension";
const deepLink = "https://metamask.app.link/dapp/spookiesclub.com/";

const msg_chain = `Please switch network to ${requiredChainIdName}!`;
export const _doThis = async (todo: any = null, prompt: any = true) => {
  const isMobile = require("is-mobile")();

  if (prompt && !MetaMaskOnboarding.isMetaMaskInstalled()) {
    if (isMobile) {
      //if (window.confirm(msg_mobile)) window.location.href = deepLink;
    } else {
      //if (window.confirm(msg_desk)) new MetaMaskOnboarding().startOnboarding();
    }
  }

  const ethereum: any = await detectEthereumProvider();

  if (ethereum && prompt && (await ethereum.isConnected())) {
    const [account] = await ethereum.request({
      method: "eth_requestAccounts",
    });
    const chainId = await ethereum.request({
      method: "eth_chainId",
    });

    if (chainId === requiredChainId) todo && todo(account, new Web3(ethereum));
    else alert(msg_chain);
  } else if (todo) {
    todo(null, new Web3(ethereum));
  }
};

export const getMerkleTree = () => {
  const elements = [
    "0xb572C63e300657CDD5eC94557cDdA46EbfdcCba5",
    "0x77aFF867c142b5BeE269EeDc0a1c0D3f88D11d46",
    "0x300Ef369708D850446dfDE4c1C14D70E358d31cc",
    "0x41347130687280Ac3DE345Cc40aB8F2195703199",
    "0x1744C9C06F973F67DCA3c788Ad7532B8Fbd74067",
    "0x7D79f0589137e04A2e99BB1dD42D402d260f026E",
    "0xFdDa77cD4d6229D988E9Cb98Dc5C94104C3F6DC6",
    "0x6140ef0c5a648125B48ef1DbACC30165Be8dDC71",
    "0x08E0148BF87adE1B7deD04F1295e0948470af7dA",
    "0xAf96514685EB4747a2baFCdA072e0A29d18a6a98",
    "0x288c82706e1f346FdA1278e87aCdcA0e0521df45",
    "0xc3866A120804B219a787Ce77E9810F4E0CbB76ff",
    "0x73aFD0D663D29dB1d9122E1e87d21Ff60ddF313E",
    "0x4d250Bc3693a5CF0096F645d0BA1bc13bd856524",
    "0xB8569a63435b283C0BE0312b06084d09C91c0512",
    "0x44E31BB80a0fbf7DA2cC2eE29091B6ebcbf6BA8E",
    "0x8Ba9297d5C517b9E3060621abd5c71feB9c6706D",
    "0xec7de3aa4e85F4b4219c2bE7c3da487460b2D3aA",
    "0xf2F7c3D701FC2D82B7926C8e940C481d88E5fC5D",
    "0xd86F80aB39482D1e85F8178C5C48Acb4E41506A0",
    "0x6c1ff800C2241E8C6F91efc9e53251D3d2B4012b",
    "0x704920E2C6bA4b803F0c19e7613423b2d479b042",
    "0x1F7D36A2a268d92bCe947BAbF0B8002b6298728c",
    "0x8E5A116e6B18b2f9637C74d2C2Ea8C7F3328881b",
    "0x5851a846C242497DBE67ec3ABaE4899677842131",
    "0x291B0708de05222159e1c4C40213dacAc2b5786E",
    "0xc3492a508Db29DecF97056EC61E803d80A904A2e",
    "0xDc9C5e34959eC3643AF1e1D34A83D6b251AAb1eF",
    "0x0e2925B0d8624f00aDf1901932D5550d43012a7b",
    "0xA3828195536462cDbaE19CB115Bb0286d3BE2571",
    "0x9710d5dDAd17d24eF17bA005E38d161e6453A526",
    "0x02cB53d691D1FbA01f2890f2BAbF36d264d1f619",
    "0x5b7a42d2751D886915d0364290a5f7a5103c2fEe",
    "0xde03ebaaa273510b14d3dd24757515f6d5e84421",
    "0x39091cd04EEAE59837B029B02696859E65E3F332",
    "0x47a9852a05da50d1ed226f1267510483971532d5",
    "0xCf02B6add93B9CE15bAa44b59DCE5954f064F1F2",
    "0x3cd40D3B42cE1b7c18d7137226Ef7221bAB8A615",
    "0x7A7f499fF4b67f77400d0892D6c50D5a1a56eb6C",
    "0xC1E5f8f617e52d3ec2ACDb39f71Bad1416568904",
    "0xb7a316Df7A14265752A0640AD851F38E3F99850E",
    "0xD9Ba40D1C8E38774CB22F9B6A8cA3707B54592D9",
    "0x9d79F12e677822C2d3F9745e422Cb1CdBc5A41AA",
    "0x93A33D5e3a20752F9aE8B9C16EDf445c5f3298C8",
    "0xd0dbe15731a136e13D9Baa10e791A6d1b25C73FC",
    "0x88762CB6B7999660e7d88B7Ea54F86b75bf2A7e3",
    "0x8319175C049fA5934338c226f213F5E9EfbD1694",
    "0x6D28E10fe48ffBE528B4E49B0136C9Dfa82D66CE",
    "0x115f9293500E5D6d7b15d13E1b20d8C1FDC3E010",
    "0x6a5bf9b61ad462ff61ceabb681918a4311ea77e1",
    "0xfFf4efa6c7F0CAdB34424Cf6aFfaAc3e44bcA4A0",
    "0x7b49F722ff9b35F920ef482474De0c856a3A5737",
    "0x0702D84108367902E30154cfE4533F0e8e1C1068",
    "0x178cb7c511B557e413f03e9A8A6fA7243d96c436",
    "0xC083073041C6C9827921e7675014e76EB98f037D",
    "0xe98EcD0ca74124E9f02Aa0D4Df931848114D1b28",
    "0x42CB81F067c0F41eC9C8766958F083DA2bEA4Cd7",
    "0x75BF9CCa07EA8b3B2546aED01fDA051F98E9Fe63",
    "0x055aBaDAED8e266C1adf0E732b97d28A0bA3D843",
    "0x9aBa7fA6310EC525Ef5dCf4D4C11391cce60346E",
    "0x5478c40F3FCC8cbe126D442991a2Dc53B34877ed",
    "0x80a3cd10d537cb1cf6d362f5312953a84cd63ae8",
    "0x4ae26f92A5b6cc29eEBD7687782ca1C96f371f1b",
    "0xfb222654e67d066F41C362302023F154e196D332",
    "0xF68B357EE3859038067aC8919C9d75Ea62FEa77e",
    "0xfBf74286495EE4aE915887939dAB2C5845D1BB65",
    "0x0c9c2f38828D4BeA23963f3198726B408a72b629",
    "0x405B95912d9d68bF19502e74FeF39AE4b23334C2",
    "0x1377915232201D671C312628278f8aA533Ce8058",
    "0x0C95A9d09A05ee44128e1F2e7df2F6529Bca61C9",
    "0x2167Da5fa374e91b9d2A16fD177A965c1701a6fb",
    "0xa0312380D88c9BC9e77DaD778C9bb150256c3c4C",
    "0x8679Bc4d30b3C80Ef233c0c215Bf801E244B9977",
    "0xDd8F8906f6076A08a17eCeF62A9f792e3a355128",
    "0xf12D114A6D40023983FfC14394951c4F8ef49183",
    "0x3FBbAF77bA1673E10391ED5906c8d8b70fF5A1D4",
    "0xA2A3F7E5871148A8f855F05FAf3F567a5815e4eF",
    "0x5e012933b4899ea725CD17A7440Cc22d0D6Aabbf",
    "0xBda354baebC88A19Ab28D133132910FD79E70c20",
    "0x0b9e1E84F4799AcAC4b2D9733Bb5B3e24022285A",
    "0x8dE0cfe895025761A0f022F6B66B9b4AE583b5d9",
    "0x617e8A256aab1e03B7aaCb048916752D4ea6969a",
    "0x8B6A48008c4c98746F169146880c8cE6Fe684f3D",
    "0x1B2D15e91DdF3269C1727629573FB2649e8431cD",
    "0xEF4aa7332fe04026E87E73eD551CDdadF60ad83b",
    "0x20fDFE1851c8C656249A973d729d9130Af0599bC",
    "0x016Eb204ea5c89D7bfd47603976d36Dc7D29b530",
    "0x53883018C0CcF29A3a42757c50b7Bb705167381d",
    "0x72DEC415BBe8Ab5466801beaB5AE2E6fa622c813",
    "0x2305e8FC192573a537610A33a8880FAF82aA87DD",
    "0x143f0eab34c5857f6e32c3b1f1dedb6b1bb1452d",
    "0x2907De8958339dE6613DC4622cec3821219096d2",
    "0x6902dbaf8a2edf27493dfbd345bcdbdc69af8ca1",
    "0xb3C828F138a60f6E3b960D51ed21D4c0CebbeB8B",
    "0xcb96eE16363e78A196ff309aB417132a169e0Dc2",
    "0x16C89E460Ef6e4feC2CC38Ab6A5b44aB6F075d07",
    "0x70b9CBC2671D323F309E7Bf046C799b1dBA9203A",
    "0xa34E8A0FcF71693af7C96D7b9547a3fE59a072Dc",
    "0x791Cb279DAb7E2191D2BEe10e51446B75375C5CE",
    "0x4b982FD77BF89AE4D2e03115064F155Dc0298a1d",
    "0xb8B5Cd7904f6e3f6943bBe6a4BFC926e6fe37E56",
    "0x5a53774cc2892BE3B83f3cE11321164044094631",
    "0xeD9D9E469A849928b6E48212AF743af884bA9845",
    "0x2eC2336dBf354E95A49CBfB3e05C42415AdCb9d6",
    "0x4d250Bc3693a5CF0096F645d0BA1bc13bd856524",
    "0xcbaB066a74e21065Ea0408dA3101688dCFa67b43",
    "0x8F01C5d3F91A45374Dca8Fc3Eb5e99AAE0eDfbED",
    "0x8BeAB6f923aC8e893eb2546Ae2fcE20148aB6B3C",
    "0x44C7f81D14a140d5aFf5c89Db7dAB045a2885D7A",
    "0x1BA8F586F6754036858A94b391E26b8Ac9c5B748",
    "0xE7b774c736d50C04487c63272d872847d46c84eA",
    "0xAFd599b429F12021bc2CA2a53AFe8d21B4587E3C",
    "0x10eefa09Fe5Ea24BB32F31F335AdA275D48F68Eb",
    "0x56955aE538E38047855c412610328543CA1F614f",
    "0xD1e6872bA505821aDc8B2aB32053fFc235E0fc1E",
    "0x80e0bABC486B4Da87597B19A80B8C7CEa787876b",
    "0x3794a1f980646BB44FFD38aF1BEeD29C6ABC6B97",
    "0x05Ade9D6Bd074606C3fBaCcdF50E1DcC89B3d09B",
    "0xB4ebA1445087d18903A43231cC3ac577C0d87Bfd",
    "0x49E8168DFf3308F833202799D8eF93dc95FE087C",
    "0xcE2C24E9DDc34f765b2dB075040Dc76Fd1c56789",
    "0x0a2a8f4B5501614b40d7938f371Dbb379e42dEaD",
    "0xCC75188ed0aA8090d6a91B28D12F96be4D44315d",
    "0xb1D98Dc719325aD0a744629701B592eADe6648F3",
    "0xF897EF93af0d5eB0c2C7757de519E077d4B7bB34",
    "0x14688bbDf01B8ef81141b475B260f4110BDe562C",
    "0x26d0dCcBe499C9bd9B9c40E74a6486dEbA893870",
    "0x4E86d54430631F7Acc61bFD58638dB08e230DDb0",
    // "OxA353f8790E828Ef7CBe8FAef906511126670086C",
    "0x2C9CA2e0Eb2cfE81954e4eC4212d089A7De8a3A2",
    "0x9c78AEbb7b702Fe06300B4Ffd308b2Dbb63A8888",
    "0xB49ea7E1637f2eC26Fbde44ed98A0E1001971D62",
    "0xfdF15839C7f75a56b92F5BEd7BDc727e1bde862F",
    "0x1ccee1d3d320486592ffee92e9efaf5e2088590b",
    "0x1dF17A99EdA4C727917EfB28E714Da6635A7a4Ed",
    "0xa9B73541Bc17Fc04b9154c5d47383Aec2FE759dB",
    "0x0b078D9e568b69A92ED610e67e0fe5b7735620a5",
    "0x3457661f0EB18AF93fF30f78Bb8df31DF4778f8a",
    "0xfb4314Adb16323D9C6f8B7B1A2e6A63A88df5Eef",
    "0x44bDc56Dd9145e9B2205f960dD7034799A269456",
    "0xfEd0ba81d9a53120747eE1dfFFDc69E5a0A0751B",
    "0xBdB4C449eD6b6104C148e28b53222b987c971C9c",
    "0x7a1c22AC253DC967021456A9f4Fd4A770b262265",
    "0x75dab91733bc68176095EC01db071b55F908a0D5",
    "0xdE65CE80566f7b03cb91cCCABe857f45218cF65D",
    "0xA05B34672288523824FDF41389CD5E2555534171",
    "0xDcF759e2D3f401Ac29658529dA7ad0Fa951040F3",
    "0x49849d3Fe590d3e7DFE552383311cD54Faf1A725",
    "0xE6ec7f3155bF378A24b93677EFf2cCF05dEF231D",
    "0xD6d6951cE0F81AAaF9c7B794105B1ae21412e67b",
    "0xEBDE31cFAE760310716Bd6C861AA84fb474e7EeD",
    "0x0739255b1c3D4a210B4c5E4D557F1Ff1742eC924",
    "0x29Ec588B736b3ED3a9F00F5667759382C75365F9",
    "0x46a6116Df23719A820309A682A5c25a8405Fb52c",
    "0xa70ab55B96Eb29354602facB4aA6867f21a9BB44",
    "0xa642fa702e112b108a50c46d716c5c09720b3680",
    "0xE25186b27c432Fc0f9af70a420E931840c979b05",
    "0x21cB29d6b063eAb51a361BcB8061af7C8be56373",
    "0x2442485EFeD286fD5Fc3A0b11B30381cfC036D98",
    "0xb0ADb5d90FdbFB2dDa9Bd7D1640aE4306F0baE45",
    "0x19fa59339dC1200820A065dd3ca911a17eba02BF",
    "0x837705bbAb4469f6E7a4A61cE1132C3C7478B72d",
    "0xE4ef84779D1c820D24fE90B0B14888501d7442DA",
    "0x01181d671479F9A9029A6dE983fB13bc59B6144F",
    "0x0D7818CBf2C679bAB04E7DE4f4f00547884084CD",
    "0xAC52BF6c83b218f51414AE6D82562075C866139C",
    "0x3757A36E493D2b248257FD2c9c4fCedb9095769A",
    "0x7c9c8047414BC2d55abD1d9AD555117d80920adC",
    "0xE025fbF48adD4Afd0CD14370c14908Dfba282E36",
    "0xD53943a4Af62F4fED17D511f150604E7e0e6007b",
    "0x14A0adF86EE9b596f93DBb7dA5AFf6Fd7d3Ff160",
    "0x0907B14771F2b04c5A4643E611d23f7e988bD35D",
    "0xb5E4b76cc106C6473Fb84C1499a06AE3589a22dA",
    "0x78EB64fD486662F06b2148d398C33777E165D727",
    "0x539f954bE21Ed5E5803B876e3178d4D30BC81D4b",
    "0x6c4cdb6eAc16a8d7B04D26C575953303AA07c565",
    "0x848Fba2129cd31844cB22DD7d0E69478bFb96F7C",
    "0x9271307799Ee65E4b4544fD76Ec18035834eBEf0",
    "0x8C65D2Ca9519deDbffD402f7f71946D4CD1AaFBD",
    "0x818b5f863419dc77a859431FB99dB936B58F93B3",
    "0x5b29091DFCc3F4F0630684818bA22b75c74bA375",
    "0x3B31ED3Db01FD45c8Ec480cB58F8d99345503452",
    "0x000012C93b4811e55E92E0DA73b93a8AEB54B915",
    "0x5dBBC818816ea815984B98005c7cefAcc9E54A6A",
    "0x1966DdCA83A3eA832B58b71c6FBF01c90477E30c",
    "0x4d0F7f2D039c9D9D48C058F63015B8bd0577FA74",
    "0xB272488eB1a6876040efe4750134E098A5d6df6A",
    "0xA2D265718Bdf70f8dEb5222E391996fe4230F026",
    "0x7Ce37AA8dDE909Bb006BF0cb5d4448Cf1687f315",
    "0x3e716A0E4dC07999Bf688d43c05dD85CB445168d",
    "0xB354DDEfadA53bC7407bFFd0a854E693690dB35f",
    "0x7fFc9858842A848eA5D614B6f0cEE5C4F75DB62E",
    "0xa9aDf22b4105717D09D2073c9963b950417e108C",
    "0xA619285Db975Ea97445776f1D106191cd71092fe",
    "0x7F669D1B1C39b134000c1a953647c3b8002b62f6",
    "0xfDECc07c57382Db62B702f227EEC3f5638D96Af1",
    "0x3f4670E20b9975b29b5a2FBB9d40206090152Ecb",
    "0xe121F2Eac2F844020d4E91F677728adBCa9985A6",
    "0xcF690F05D9b3E88164371182F2eDa3E3349175D4",
    "0x3482F3588214655DA80D504c9B755ae3cDbf271b",
    "0xBef81E9af99b06b6Fa62750453Eab8c82C6b12A7",
    "0x3226Ab612f925e41dE1A2f25464F611E9bF0bE5E",
    "0xEA0a2F52b8E6e43eeb908f488Ed18a8cBd4144B0",
    "0xd90e67F48e981F7d6d58960129690adbDDEd5f6d",
    "0x7a0EF482134aa53468850A7b117EcA38A6a3003D",
    "0xE64a741649a4A9b9d35cB6D2784939DD7F84C18f",
    "0x7677860b03585b5Faa926Bf522EbE4E704db18eB",
    "0x5D727e60A27dB601223B8CFD26e6f2595c6643fF",
    "0x86fb0aaf43C0a5DCf59a4e34357315a03aEd5E99",
    "0x91b4ade96e8d0eefdf2a57cef161d13dc633e0d7",
    "0x38fAe8DE066c8053AC38Ab625C35A87A9CEF727B",
    "0x9160631E2d921DEeB7ea438B9aF1336Aa81bB7b7",
    "0x2550Fa32D1E8B5518ed8DC504c71A98f10576204",
    "0x52A53B76C7b199a37522Bef96CfE3d8Fc35f8476",
    "0x4202870DB7fb3BfcE3DA023eCD0c1858fA412a32",
    "0x32Dd5F81Fd97E67aC89EEe34d37F3A577b909302",
    "0x34B53eA3F8EE26857d08341245Bb66CDae74d486",
    "0x0a6A5356360843650D26969742Ee0Ce892DE1D5c",
    "0x170E6e7760a23461D85ec0171DE31206385973F6",
    "0xBb342c4f2357Fbb918586377e0D0D50BA9630c41",
    "0xf6C89E23bC80a6505F3852912Bc38CCFc74C93F0",
    "0x64ac3C989c2be1538F74C192E5AD78fdd3D2629f",
    "0x334592F11a944650283649CbcFE0A532CB539667",
    "0x4EF7D3b9e4CB2ECd0E581cB78ba7079A79aFD74F",
    "0xE398ead4841DD83e9590122bd0ee15419a311e7A",
    "0xb62156B7ea5fb36a818963A659CCf7AA85DAb239",
    "0xc265209d120f33949d76a2033d4453c10a4111bc",
    "0x0D7818CBf2C679bAB04E7DE4f4f00547884084CD",
    "0xB75595e54b0B3E031B8cBfB859AA3Fb879DAC4bd",
    "0xebf911299A4350165F8045BD773A8872010565ad",
    "0x48E4cf667A70652fa974078F95d00B0B3cF016D5",
    "0x6B6b9bf52c354311fE89230e519A41cae0c24463",
    "0x8148087ECF542Af44b950893Fef02C4E1cdC0C69",
    "0x2Ea6539Ca4CCdd05c255836807Dac22BBE2a8Faf",
    "0x251Eef911922Cbb67AEDad5426F200787B2CD2f0",
    "0x9f4c8D1a34216050c8CF91c6dAc6633B4c1A0C48",
    "0x7Ff340d0efADaa04c8FE1E45f79cb55Be42Cdf58",
    "0x3F03C719EA81199fE9427181A237dbACf3478ace",
    "0xedd686ff7B073184F6938BF50F658902094e6Bcd",
    "0x2a6CAC23d3b6A79D98700D127aCf7D1DC57dd907",
    "0x68A5EA6d7f1bE573CD3b2209e47EA6D5fDa98581",
    "0xfce05a623e4b42751233717a4c0ef55826bee7e8",
    "0x880668067bE9CA061EaED9F247f5CB6307E34Cc8",
    "0x3d15037B215732EBd53CD437D8a00568124EA667",
    "0xc1239DB486877D391609D6C5f903A4c3f9B48687",
    "0x55cb8A133ac8529606D2Dcd07941688f009223e6",
    "0x8837aedc77cfadD23A06126FDB2A13a2232c7D3F",
    "0x6c4cdb6eAc16a8d7B04D26C575953303AA07c565",
    "0x4C7DCd4599AADc000Dae3c4524a31f7a04E29525",
    "0x44E31BB80a0fbf7DA2cC2eE29091B6ebcbf6BA8E",
    "0x0b3AD672F088896f099D1FB16704411dD21707d4",
    "0x86946c0f75A6E804173e23F2308f746C68a79225",
    "0x138BF46C7BAAF079111402f800762b001eA81442",
    "0x3D0Df7eb6369e3f52644981f8aC4D1bF756FcEae",
    "0x5B5ba81777419E7b2Ea17C4b987e9241a3CE04A0",
    "0x488606F5f2bB180a7851F939244BDFaFc5ed4b61",
    "0xcb5Cb91c399F1374e32C90Bb020fB97fE5415187",
    "0xd46E54bF21Ba9d319d82AdfBC544eedD1e9B7731",
    "0xECB03558D2dEE04b957DDa1242F6bD8DB0287860",
    "0x481ba4d2DE35293520155E68b7491b5F5C3040Ed",
    "0xc3898CcCB943139ae9926EFb995023B2F079b4fb",
    "0x225EAB157AD891c1203C8341F00088381Cf9a9e8",
    "0x0364F3AB4dfEE2C69e3414adc6D8893618661bfC",
    "0x94e7E7a0107F3Ad75126fA20a43cC46cc8CCd711",
    "0x0745b719eF5aDBbF06d155b58801C2C1961f9EE1",
    "0x8aE7343952D9755d3b46DA7770d37abC895F8079",
    "0x82811b821D42103Db21e31cA30ad8b75AB5f96Ca",
    "0x71A6EbC077dD13AeafBC6Eeb571a35B0Ea0e0261",
    "0x58af9f2968895B7BD8EeaC9F916F98fE4467e7dc",
    "0x2684dFeAB54A803Ed77e4adaE9b8291dF8d6d090",
    "0xA9CC79c0D38782257e3aF2ef08182161693723e1",
    "0xE025fbF48adD4Afd0CD14370c14908Dfba282E36",
    "0x74A7B02ea75923a0364d58cE051748Af1Dd88cCb",
    "0x8C65D2Ca9519deDbffD402f7f71946D4CD1AaFBD",
    "0xf62c9b60299D7ADDd8e2db388a426283d2476755",
    "0x1C95788b7eFD30C1BD4281f6eA0a1617Bb2c9531",
    "0x7F669D1B1C39b134000c1a953647c3b8002b62f6",
    "0x9957Bea6dBb7cB980c5c02D8100287eb138fa846",
    "0x9031DC4bf90194c311936130A883d71bee1F1B59",
    "0x1f4310af9d40cA99875731788CD8C268D71CF27b",
    "0x574EAbc8e7c9015c5aDDB9bCfBAdf5825f34f25a",
    "0x29209A061B376cAB20E821dC5223b6e6a9256D69",
    "0xd70cC1458A165D5057b368564a3327cdfF5134E0",
    "0x9451c5b84721c0e980c1805620da085f265aaf11",
    "0x4a8dFad244e84197699C71510A8aA387F615A485",
    "0x3226Ab612f925e41dE1A2f25464F611E9bF0bE5E",
    "0xBb7B519E9972C418ba2b434F60F3E840c8966A09",
    "0x09dbE191065884cF36C18bfa5A9Fde973edC86E3",
    "0x723f67E880e8824A183c27e4aFE06ba1CCae5799",
    "0x995e7FC77F43343A23A90c65e4Ea84F7b54B24E9",
    "0xB390B5C710e4aCc288B54f47f2D194a47c58E4B8",
    "0xFAD864bc28865860dDF6afbfEA9B297b75c49d7A",
    "0x32Dd5F81Fd97E67aC89EEe34d37F3A577b909302",
    "0x3482F3588214655DA80D504c9B755ae3cDbf271b",
    "0x3fF9cfFdA13189398e637F22E4E8e4620A034cc7",
    "0x72eE4aDf042A8A53fA133F1ddbB4326AF4430976",
    "0x359a914EBAA1F579C571F78A95F60106047340Ea",
    "0x334592F11a944650283649CbcFE0A532CB539667",
    "0xA2D265718Bdf70f8dEb5222E391996fe4230F026",
    "0x6c4cdb6eAc16a8d7B04D26C575953303AA07c565",
    "0x49aE565d1EB60A6095475C113486eb461AebE47a",
    "0x8E1c8B58edaFbfd56B9764B32aC4578de9f76569",
    "0xcd9CF83dd90b9b8eBcfE3de49F6DaCc97EAf0F7F",
    "0xefAeCb9CCbBF1A033676117FCCeB1A06710e422b",
    "0x3f932C2Af7879CCA973Ec979311fb997B3fb4746",
    "0x827ea61a31DE8c2677478CF28769de61509648e6",
    "0x1Ff529672A0e2b14b5ededDD277D642AFfd1314c",
    "0x68e9c7351c4e3d145c3452278E71324AE6C74975",
    "0x5e65aeDC22dCb308713B38141EE97232B32f2a18",
    "0x78EB64fD486662F06b2148d398C33777E165D727",
    "0x741aaEA52E2D9C815c6c0B9512e956D7094a2933",
    "0x52A53B76C7b199a37522Bef96CfE3d8Fc35f8476",
    "0x55f0926704fD1612Ce9282abd1cB2153163DAdBa",
    "0x5809Ee96D141D0Cdc3AD4D987F4293eEa8Ee0f3F",
    "0x3Ff0df7EC6Ab47725272691a030c22a59bc87B1D",
    "0x96A3D43FE2eD2f19D40d1059E4d849979dB3CD5e",
    "0xA64E6A0885667A9C21de862c830Ad688C185AC6e",
    "0x8063A2B8A97729ce8dD5459754Ea233C067cb5E4",
    "0x7c9c8047414BC2d55abD1d9AD555117d80920adC",
    "0xac665222da6E9DFE15497d91d9850ca567742B4E",
    "0x06598f9f281Acc62Ff170730A4be2F9fec402C53",
    "0xD4A13A41598e1404a019D025F14a60C796d21aa9",
    "0x43205834Bb98721224CAc315D20B04760bB94e24",
    "0x7C4F32d702C5327ac7A1BfB404fB27cE95eD6BE3",
    "0x3d15037B215732EBd53CD437D8a00568124EA667",
    "0xAFD14926c9EFB30371C0D8b6bD983576afC3844B",
    "0x5dBBC818816ea815984B98005c7cefAcc9E54A6A",
    "0xe121F2Eac2F844020d4E91F677728adBCa9985A6",
    "0xcD7ea49c3033f80A9D453d04c8Cb78e4D9936954",
    "0x5e39F37B10FD3d55F27aA21f4b82a03bd0AB34A2",
    "0xdCdf631F05A7E9466E96163db0A59681B08F4c4c",
    "0x9271307799Ee65E4b4544fD76Ec18035834eBEf0",
    "0x848Fba2129cd31844cB22DD7d0E69478bFb96F7C",
    "0x51eF3246871787E634ca15c735f03800C5984B62",
    "0xC80a3538Ed55D9a4513c1ADAB03388278EB278eD",
    "0x0694C4E908F5f010b02F2510d6bd37E62A4fa02b",
    "0x4306b3475c25db625b1df6b5b9ecfe859e01be19",
    "0x6Fd69073f458Ed3566DDd7f9F37409994bA59A78",
    "0x21e82a9Ae72dF4bD70Cc6240CB79FFeFf5697eF8",
    "0x4b98A73bFa1Ad8776DC9474887C3547B3cf1e59D",
    "0x3757A36E493D2b248257FD2c9c4fCedb9095769A",
    "0x6E95099CACdcc9f024C701f88964688588754dfb",
    "0xfDECc07c57382Db62B702f227EEC3f5638D96Af1",
    "0xCe1C7D5e97781cA140e0fbD4281fbf118414Be90",
    "0x5c7DceC6900f498e32557361924215Cb3C83c9fc",
    "0x3e716A0E4dC07999Bf688d43c05dD85CB445168d",
    "0x54f27d9df4d47A9DF69F58Ce386204b549Df0CEc",
    "0xf5F8DD66f5359C2b8E2990Be6D6c0bC762D5E575",
    "0x2Fa034324000ebF5967cb45FF360cd93c7090A7a",
    "0xB354DDEfadA53bC7407bFFd0a854E693690dB35f",
    "0x14A0adF86EE9b596f93DBb7dA5AFf6Fd7d3Ff160",
    "0x0745b719eF5aDBbF06d155b58801C2C1961f9EE1",
    "0x4026d6398fe7277281b3DCF947684e6380cC6F1f",
    "0xd649946076d587Af74CAd517734935018a54cc2a",
    "0x867E4de406ACF7Aa9162a5dAA6198e27E8434D5A",
    "0x0907B14771F2b04c5A4643E611d23f7e988bD35D",
    "0x2F530474ae9e916cFe40b031Da957F569C915514",
    "0x044c1Cca58EF406DDA05e2F409c6B7F8588232Db",
    "0xD97324D9720B50Aa7d65D38aDcA68bd0Bb399516",
    "0x3dF49dB1609300ff87F50a3A36F8b49563CDdDd2",
    "0xB8e72AF9C3683Fe949a7B056A7525506cF33d6A2",
    "0x4bd39D06ADb265B8b6cA11314e332A85fB344827",
    "0x3fec67ee3375EE28c471a12c7a5f45c58B715971",
    "0xf62de7221bE9AeB07FaCF1E56e5809E8c4CCA364",
    "0xca1d749457109cfc162dd4fdab7e1956dfebdfb0",
    "0x6D1fa41D45f6158157d90d765B395662E59542F2",
    "0x818b5f863419dc77a859431FB99dB936B58F93B3",
    "0x3D670681bd5594C3063302a757071A4D87fE439d",
    "0x5b29091DFCc3F4F0630684818bA22b75c74bA375",
    "0xDD1541020ac996e75C37EF3Fb17570B8E20279B6",
    "0xeCd9786da7D25610761Baa16943b9f98F7959f3c",
    "0xfdF15839C7f75a56b92F5BEd7BDc727e1bde862F",
    "0xFBab97A84F202A8C4545A57213601Bd413DA8bcb",
    "0x6Ec3951505f4f38e5E3e42be06F3877B375e1bFc",
    "0x251Eef911922Cbb67AEDad5426F200787B2CD2f0",
    "0x53fe99dc3D895dcB8A5A85B96247f2455c833b36",
    "0xA619285Db975Ea97445776f1D106191cd71092fe",
    "0xEFE8589BE396e394626bF781eedc1783d816495c",
    "0xEA0a2F52b8E6e43eeb908f488Ed18a8cBd4144B0",
    "0x8Dd13798Da3f75A472529aFE5B76e6a74c962b84",
    "0xAA05853E72b0C8600d7727C9DF2a880BdB9A75d9",
    "0xAA22Bf3D4c959d3903290606ba07357a2f5a33d6",
    "0xfa94C910186b8b637742d087cE8877bBd085CBd4",
    "0xD6D2A5f9Cc6dC218998cb149DDAB8891bc3b1FF4",
    "0xAfC6f259b238FCB10E58ad61aE8599BA51e2239E",
    "0xBdB4C449eD6b6104C148e28b53222b987c971C9c",
    "0x9dDB8209d9A8518F0F4099B3382De37F55DC623C",
    "0x9E541591BA99D3dc126eaAf654fbF6840978b2Fa",
    "0xE6ec7f3155bF378A24b93677EFf2cCF05dEF231D",
    "0xB8E30EBa9ac02C3d71A197370BA5ed8C8e0b7CD8",
    "0xbBD138dfd97AA24AeC03Fbb97Ac1c16d0D498FFA",
    "0x9777b74CDA631dc32cEeF05Bb1B67a612A176D10",
    "0x1dF17A99EdA4C727917EfB28E714Da6635A7a4Ed",
    "0x41D8FE5D5A62e455C8cd33bDee8ecE7D4eA6aaCb",
    "0x67DDBA10220cFFC8689A688E43D7Ee4365749a8C",
    "0x0E43A68B2D9185f5f56BDfde4C5b9eB5cd9a2Ef6",
    "0xD3bFCD76F8278a9e449AaeEC2cB2DFD2cFD215A5",
    "0x7677860b03585b5Faa926Bf522EbE4E704db18eB",
    "0x9c78AEbb7b702Fe06300B4Ffd308b2Dbb63A8888",
    "0x8c948d0ff53732CFFD549C9F44A3242b76F4872a",
    "0xd4dFf494527500241126DDF910a0b21fe09D6990",
    "0xECB03558D2dEE04b957DDa1242F6bD8DB0287860",
    "0x5E6c930A16841c384DEb7466c92D1aa168E3e7b0",
    "0xba73982421b29D422Be578556aaB17a0A250ac89",
    "0x94e7E7a0107F3Ad75126fA20a43cC46cc8CCd711",
    "0x0D14C55fAf2d24c78a9e181Db160581361da5f7B",
    "0xB80c66Bad235E63d4a3Df5fc1472752F87c36D10",
    "0xb467FFB18244536b10CcFA0Ed1Bd261323a063Ff",
    "0x9A90403F04B4a4Ca79c950214252d70C7E84195a",
    "0x8B534187Ae5Ee1CD93458CD5011C4A695E6A7433",
    "0x30f07bEaDF404031689c9c1016bB9810ffdE0755",
    "0x4984b03989319d55e5Ad6C6Df62c32a5B3EeC8EA",
    "0xf98e8D1009E3f4E2b8899A275bbCD3bbF59ad6A6",
    "0x1F7C91B24bf54Cf38be173D292ad1584E2a29578",
    "0xeD7B34A668095C914fA62a3185e7E3C4c9a41aBC",
    "0x3457661f0EB18AF93fF30f78Bb8df31DF4778f8a",
    "0xfEd0ba81d9a53120747eE1dfFFDc69E5a0A0751B",
    "0x9160631E2d921DEeB7ea438B9aF1336Aa81bB7b7",
    "0x2550Fa32D1E8B5518ed8DC504c71A98f10576204",
    "0x7CC6269dC4c296ddcb99E2ecC05dD1a5E51d4Ef4",
    "0x44bDc56Dd9145e9B2205f960dD7034799A269456",
    "0xb21439d9BC421735f74afb8B17F9A11971aF6Adf",
    "0x6B4E12259153FE926f678f8810E1eF351ADf9226",
    "0x75dab91733bc68176095EC01db071b55F908a0D5",
    "0x3df5e7679b142a8337c3583c6b4f493D0f235482",
    "0xd81c2F6ae8289D0CFF914C8F92A38E7f49F67895",
    "0x676c4AD5DceD9489140a7Db75cF72273D777d537",
    "0xFa0b481C5840881Cd658c18bE6a7a6637F657520",
    "0x04879541D2AdA25bCC6aB2A67C96662D7267163b",
    "0x67DbC9d73294bB26D0990543e9b3A9d2297d1ebd",
    "0x4bF7D07B558d14cAB201E12c6d23bA541E83fc65",
    "0x0d58dCC12300b3C11e5C08E979F908E2B218Ea57",
    "0x15F75f25A3B2021EEBD304Bc4051c642E680307d",
    "0x6B738B86848B4233c0D8eA1d41Fec93e31e43CDA",
    "0xee067F8460bf3fd9926a8C6cE132E5E09eE9612e",
    "0x78cE72598A88bCC2812635CEDC2B8a473757Af5F",
    "0xfb4314Adb16323D9C6f8B7B1A2e6A63A88df5Eef",
    "0xC380730412c1a7b01730F82b79460985fd111b94",
    "0x9B6743674fAF5Dde94f72951e0f5239C9452D34E",
    "0x117800D5f8037D1ccDbD31A3282EB8566769688d",
    "0x0FbD899026a88Bca92eC2d37131f01Eb6FC176d7",
    "0x9E2c0aF3688ee66d86b93d931856A2dd4BC52C9D",
    "0x613773400314bEE4A83B568EAb2C200Eb0D665c7",
    "0x7CC6269dC4c296ddcb99E2ecC05dD1a5E51d4Ef4",
    "0xf8B9f266A1b9C294be8502D6270981053af985bE",
    "0x67D2d2B284d812E1315371995CF469f133d0173c",
    "0x41018674bdf7aD5E341CC07a2686c04BDb76315D",
    "0xE8ba0714cBcfEBc2A821dCdf6E348c9F6a5caaD0",
    "0xfb4314Adb16323D9C6f8B7B1A2e6A63A88df5Eef",
    "0xfEd0ba81d9a53120747eE1dfFFDc69E5a0A0751B",
    "0xB641C17C1bA12c2B2e97315beEd388D9b039e3BD",
    "0x8805e7dEb2Bdb86cCD441E1DcAC40272e30E922C",
    "0xECd08825af1D09A2c2f509fa5aB348C45f9cB406",
    "0x6558480DbB7D2B3E9F5bc275dEfDa282eA9f7F93",
    "0x24bCD423B40f799413479CB85136A09Dc3439F84",
    "0x997dCc4f1689e38709c888596572CBe6e1430ab8",
    "0x6712662BC8D1A2421a10CbcbFC91E9f0AF1bBAd9",
    "0xA01575aa8B036A6A9F7cdB9a197a2AfaC7B31890",
    "0x8c9902A6a8b602e2983CeAB6f40C68214d0C61Be",
    "0x2D2563E40Af14ee8E98cd5C16ec54Ed978c13A31",
    "0x97F3aee52f15c18CE357d3803cb1E64433eab389",
    "0x6A9932B6E90A1fd9072b6cd8622E538816b2026a",
    "0xfDFF056e9e769DD8AC538fC1B037A0909B43Ac16",
    "0xEB405f9e82e9D5ab3eAA13F8A5cD01780EC98544",
    "0xA3828195536462cDbaE19CB115Bb0286d3BE2571",
    "0xfDFF056e9e769DD8AC538fC1B037A0909B43Ac16",
    "0x6A9932B6E90A1fd9072b6cd8622E538816b2026a",
  ].map((a) => toChecksumAddress(a));

  return new MerkleTree(elements, hash, {
    hashLeaves: true,
    sortPairs: true,
  });
};
